export default __webpack_public_path__ + "static/rombo-prints-8f613a436d1ab36fa21bf094aba4c573.jpg";